import { danmakuMoments } from "@/mocks/index";

export default function DanmakuSection() {
  return (
    <section id="danmaku" className="scroll-mt-20 bg-stone-900/60 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          {/* 左：主视觉 + 文案 */}
          <div className="lg:col-span-5">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-3.5 py-1.5 text-xs font-medium text-amber-300">
              <i className="ri-fire-line" />
              高能弹幕集中地
            </div>
            <h2 className="text-2xl font-black text-white md:text-4xl">弹幕合集 · 名场面考古</h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-400 md:text-base">
              画面没接住的梗，评论一个不落全给圆回来。我们把当晚最出圈的那几句弹幕、最经典的错位与许愿成真都整理进合集，点开就是满屏“好活”。
            </p>
            <a
              href="#now"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-amber-400/40 bg-amber-500/10 px-6 py-3 text-sm font-medium text-amber-200 transition-colors hover:bg-amber-500/20"
            >
              <i className="ri-play-list-2-line" />
              去看弹幕回放
            </a>
          </div>

          {/* 右：弹幕时间线列表 */}
          <div className="space-y-3 lg:col-span-7">
            {danmakuMoments.map((d, i) => (
              <a
                key={i}
                href="#danmaku"
                className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-4 transition-colors hover:border-amber-400/40 md:px-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/5 font-display text-sm font-bold text-amber-300 group-hover:bg-amber-500 group-hover:text-stone-950">
                  {d.time}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm text-stone-100 md:text-base">
                    {d.hot && <i className="ri-fire-fill mr-1.5 text-orange-400" />}
                    {d.text}
                  </p>
                  <p className="mt-1 text-xs text-stone-500">该时间点弹幕峰值约 {d.count} 条 / 分钟</p>
                </div>
                <i className="ri-arrow-right-line shrink-0 text-stone-500 transition-transform group-hover:translate-x-1 group-hover:text-amber-300" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}